<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-lg-12 p-0 custom-form-label">
        {{$t('scheduling_recurrency')}}
      </div>
    </div>
    <div class="row mt-1">
      <div class="col px-0">
        <select v-model="selected" v-bind:id="'select_schedule_option' +  getId()" class="form-control schedulerselect" v-select @change="emitChangeType">
          <option value="">{{$t('schedule_once')}}</option>
          <!--<option value="everyday">{{$t('schedule_everyday')}}</option>-->
          <option value="everyweek">{{$t('schedule_everyweek')}}</option>
          <option v-if="showNewUserOption===true" value="newuser">{{$t('new_user')}}</option>
          <option v-if="showOnProcedureDoneOption===true" value="onproceduredone">{{$t('on_procedure_done')}}</option>
          <option v-if="showAddedToTeamOption===true" value="addedtoteam">{{$t('added_to_team')}}</option>
          <!--<option value="everymonth">{{$t('schedule_everymonth')}}</option>-->
        </select>
      </div>
    </div>
    <div class="row mt-3" v-if="selected == 'everyweek' || selected == 'once' || selected == ''">
      <div class="col-6 pl-0 custom-form-label">
        {{$t('schedule_startday')}}
      </div>
      <div class="col-6 pr-0 custom-form-label">
        <span v-if="showTimeOption===true" class="">
          {{$t('time')}}
        </span>
      </div>
    </div>
    <div class="row mt-1" v-if="selected == 'everyweek' || selected == 'once' || selected == ''">
      <div class="col-6 pl-0 custom-form-label">
        <input type="text" v-bind:id="'txt_startdate_' +  getId()" class="form-control schedulerstartdate" style="display:inline;" />
      </div>
      <div class="col-6 pr-0 custom-form-label">
        <input v-if="showTimeOption===true" type="text" v-bind:id="'txt_time_' +  getId()" class="form-control" style="display:inline;" v-model="time" placeholder="HH:mm" />
      </div>
    </div>

    <div class="row mt-3" v-show="selected == 'everyweek' && showEndDateOption==true">
      <div class="col-6 pl-0 custom-form-label">
        {{$t('schedule_endday')}}
      </div>
      <div class="col-6 pr-0 custom-form-label">
        <span v-if="showTimeOption===true" class="">
          {{$t('time')}}
        </span>
      </div>
    </div>
    <div class="row mt-1" v-show="selected == 'everyweek' && showEndDateOption==true">
      <div class="col-6 pl-0 custom-form-label">
        <input type="text" v-bind:id="'txt_enddate_' +  getId()" class="form-control schedulerstartdate" style="display:inline;" />
      </div>
      <div class="col-6 pr-0 custom-form-label">
        <input v-if="showTimeOption===true" type="text" v-bind:id="'txt_endtime_' +  getId()" class="form-control" style="display:inline;" v-model="endtime" placeholder="HH:mm" />
      </div>
    </div>
    <div class="row mt-3 px-0" v-if="selected == 'everyweek' && showWeekRepeatOption==true">
      <div class="col-6 pl-0 custom-form-label">
        {{$t('schedule_repeat_each')}}
      </div>
    </div>
    <div class="row mt-1 px-0" v-if="selected == 'everyweek' && showWeekRepeatOption==true">
      <div class="col-6 px-0">
        <input maxlength="2" type="number" v-model="weekRepeat" class="form-control" style="display:inline;" />
      </div>
      <div class="col-6 pr-0 pt-1">
        {{$t('week')}}
      </div>
    </div>

    <div class="row mt-3 px-0" v-if="selected == 'everyday'">
      <div class="col-6 pl-0 custom-form-label">
        {{$t('schedule_repeat_each')}}
      </div>
  </div>
  <div class="row mt-1 px-0" v-if="selected == 'everyday'">
    <div class="col-6 px-0">
      <input maxlength="2" type="number" v-model="dayRepeat" class="form-control" style="display:inline;" />
    </div>
    <div class="col-6 pr-0 pt-1">
      {{$t('day')}}
    </div>
  </div>

  <!--<div class="row mt-2" v-if="selected == 'everyweek'">
    <div class="col mb-2">
      {{$t('schedule_repeat_each')}} <input type="text" class="form-control" v-model="weekRepeat" style="max-width:40px !important; height:20px; display:inline;" /> {{$t('schedule_th_week_on')}} <br />
    </div>
  </div>-->
  <div class="row mt-2" v-if="selected == 'everyweek'">
    <div class="col-6 px-0">
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Monday')" @input="setOverride" value="Monday" id="schedule_mon" name="weekday" v-bind:text="$t('monday')" class="mt-1"></input-checkbox>
      </div>
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Wednesday')" @input="setOverride" value="Wednesday" id="schedule_wed" name="weekday" v-bind:text="$t('wednesday')" class="mt-1"></input-checkbox>
      </div>
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Friday')" @input="setOverride" value="Friday" id="schedule_fri" name="weekday" v-bind:text="$t('friday')" class="mt-1"></input-checkbox>
      </div>
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Sunday')" @input="setOverride" value="Sunday" id="schedule_sun" name="weekday" v-bind:text="$t('sunday')" class="mt-1"></input-checkbox>
      </div>      
    </div>
    <div class="col-6 px-0">
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Tuesday')" @input="setOverride" value="Tuesday" id="schedule_tue" name="weekday" v-bind:text="$t('tuesday')" class="mt-1"></input-checkbox>
      </div>
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Thursday')" @input="setOverride" value="Thursday" id="schedule_thur" name="weekday" v-bind:text="$t('thursday')" class="mt-1"></input-checkbox>
      </div>
      <div class="col">
        <input-checkbox v-bind:checked="weekDayExist('Saturday')" @input="setOverride" value="Saturday" id="schedule_sat" name="weekday" v-bind:text="$t('saturday')" class="mt-1"></input-checkbox>
      </div>
     
    </div>
  </div>
  <div class="row" v-show="selected == 'everymonth'">
    <div class="col px-0">
      <select v-model="selectedMonth" class="form-control schedulerselect" v-select>
        <option value="">{{$t('schedule_select_month')}}</option>
        <option value="jan">
          {{
$t('month_jan')</option>
          <option value="feb">{{$t('month_feb')
          }}
        </option>
        <option value="mar">{{$t('month_mar')}}</option>
        <option value="apr">{{$t('month_apr')}}</option>
        <option value="may">{{$t('month_may')}}</option>
        <option value="jun">{{$t('month_jun')}}</option>
        <option value="jul">{{$t('month_jul')}}</option>
        <option value="aug">{{$t('month_aug')}}</option>
        <option value="sep">{{$t('month_sep')}}</option>
        <option value="oct">{{$t('month_oct')}}</option>
        <option value="nov">{{$t('month_nov')}}</option>
        <option value="dec">{{$t('month_dec')}}</option>
      </select>
    </div>
  </div>
  <div class="row" v-show="selected == 'everymonth'">
    <div class="col-6 px-0">
      <select v-model="selecteddayoption" class="form-control schedulerselect" v-select>
        <option value="day">{{$t('schedule_option_day')}}</option>
        <option value="on">{{$t('schedule_option_on')}}</option>
      </select>
    </div>
  </div>
  <div class="row" v-show="selected == 'everymonth' && selecteddayoption == 'day'">
    <div class="col px-0">
      <select v-model="selectedday" class="form-control schedulerselect" v-select>
        <option value="">{{$t('schedule_select_day')}}</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
        <option value="13">13</option>
        <option value="14">14</option>
        <option value="15">15</option>
        <option value="16">16</option>
        <option value="17">17</option>
        <option value="18">18</option>
        <option value="19">19</option>
        <option value="20">20</option>
        <option value="21">21</option>
        <option value="22">22</option>
        <option value="23">23</option>
        <option value="24">24</option>
        <option value="25">25</option>
        <option value="26">26</option>
        <option value="27">27</option>
        <option value="28">28</option>
        <option value="29">29</option>
        <option value="30">30</option>
        <option value="31">31</option>
      </select>
    </div>
  </div>
  <div class="row" v-show="selected == 'everymonth' && selecteddayoption == 'on'">
    <div class="col-6 px-0">
      <select v-model="selectedmonthon" placeholder="select" class="form-control schedulerselect" v-select>
        <option value=""></option>
        <option value="first">{{$t('schedule_first')}}</option>
        <option value="second">{{$t('schedule_second')}}</option>
        <option value="third">{{$t('schedule_third')}}</option>
        <option value="last">{{$t('schedule_last')}}</option>
      </select>
    </div>
    <div class="col-6 px-0">
      <select v-model="selectedmonthonday" class="form-control schedulerselect" v-select>
        <option value="">{{$t('schedule_select_day')}}</option>
        <option value="monday">{{$t('monday')}}</option>
        <option value="tuesday">{{$t('tuesday')}}</option>
        <option value="whednesday">{{$t('wednesday')}}</option>
        <option value="thursday">{{$t('thursday')}}</option>
        <option value="friday">{{$t('friday')}}</option>
        <option value="saturday">{{$t('saturday')}}</option>
        <option value="sunday">{{$t('sunday')}}</option>
      </select>
    </div>
    <div class="row">
      <div class="col px-0">
        <button type="button" class="btn skin primary-button" @click="addschedule()">{{$t('schedule_add_schedule')}}</button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>

  var selected = "";
  var selectedMonth = "";
  var selecteddayoption = "";
  var selectedday = "";
  var selectedmonthon = "";
  var dayRepeat = 0;
  var selecteddate = "";
  var time = "";
  var weekRepeat = 0;
  var endtime = "";
  import InputCheckbox from "../form-components/input-checkbox.vue";

  export default {
    name: "create-schedule",
    components: {

    },
    props: {
      weekdays: {
        type: String,
        default: ''
      },
      showNewUserOption: {
        type: Boolean,
        default: true
      },
      showTimeOption: {
        type: Boolean,
        default: false
      },
      showOnProcedureDoneOption: {
        type: Boolean,
        default: true
      },
      showAddedToTeamOption: {
        type: Boolean,
        default: true
      },
      showEndDateOption: {
        type: Boolean,
        default: true
      },
      showWeekRepeatOption: {
        type: Boolean,
        default: true
      },
    },
    data() {

      return {
        selecteddate,
        selected,
        selectedMonth,
        dayRepeat,
        selecteddayoption,
        selectedday,
        selectedmonthon,
        time,
        weekRepeat,
        endtime,
      };
    },

    methods: {
      emitChangeType() {
        this.$emit('changetype', $("#select_schedule_option" + this.getId()).val());
      },
      weekDayExist(weekday) {
        if (this.weekdays !== '' && this.weekdays !== undefined && this.weekdays !== null) {
          return this.weekdays.includes(weekday);
        }
        return false;
      },
      setControls(type, date, weekdays, time, enddate, endtime, weekrepeat) {
        this.selected = type == 'once' ? '' : type;
        $("#select_schedule_option" + this.getId()).val(this.selected);
        $("#select_schedule_option" + this.getId()).trigger('change');
        $("#txt_startdate_" + this.getId()).val(date);
        //this.selecteddate = date;
        //$("#txt_time_" + this.getId()).val(time);
        
        this.weekdays = weekdays;
        this.time = time;

        if (this.selected === 'everyweek') {
          $("#txt_enddate_" + this.getId()).val(enddate);
          this.weekRepeat = weekrepeat;
          this.endtime = endtime;
        }
      },
      clearFields() {
        $("#select_schedule_option" + this.getId()).val('');
        $("#select_schedule_option" + this.getId()).trigger('change');
        this.selected = '';
        this.weekdays = '';
      },
      setOverride(val, value) {
        if (this.weekdays === null) {
          this.weekdays = '';
        }
        if (val) {
          this.weekdays = this.weekdays.concat(value + ',');
        } else {
          this.weekdays = this.weekdays.replace(value, '');
        }
       
      },
      getId() {
        return this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      getSchedule() {

        this.selected = this.selected == '' ? 'once' : this.selected;

        var endDate = '';
        var weekRepeat = null;
        var endtime = '';
        if (this.selected !== 'everyweek') {
          this.weekdays = '';
        }

        if (this.selected === 'everyweek') {
          endDate = $("#txt_enddate_" + this.getId()).val();
          weekRepeat = this.weekRepeat;
          endtime = this.endtime;
        }
        if (this.time === null) {
          this.time = '';
        }
        if (endtime === null) {
          endtime = '';
        }
        var request = {
          type: this.selected, StartDate: $("#txt_startdate_" + this.getId()).val(),
          Weekdays: this.weekdays, Time: this.time, Endtime: endtime,
          EndDate: endDate,
          WeekRepeat: weekRepeat,
        };
        return request;
      },
      addschedule() {

      }

    },
    computed: {

    },
    mounted() {
      $('.schedulerselect').select2();

      var locale = $.datepicker.regional[this.$store.getLocale()];
      var d = this.$store.getMomentLocale(new Date());

      var settings = {
        autoUpdateInput: false,
        locale: locale,
        startDate: d,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1901,        
        maxYear: parseInt(moment().format('YYYY'), 10),
        drops:"up"
      };

      var thisContext = this;

      $('.schedulerstartdate').daterangepicker(settings);

      $('.schedulerstartdate').on('apply.daterangepicker', function (ev, picker) {
        var tmp = thisContext.$store.getMomentLocale(picker.startDate);
        $(this).val(tmp.format("L"));
      });

      $('.schedulerstartdate').val("")
    },

    created: function () {

    },

    watch: {

    },
    created() {

    },
  };

</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/scheduling/create-schedule.vue